import { Grid2, IconButton, TableCell, Typography } from "@mui/material";

import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import countries from "world-countries";
import * as Yup from "yup";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import { JobIndustryList } from "../../../../redux/action/Job";
import {
  CreateNewRelationshipCall,
  VendorDelete,
  VendorTableGetCall,
} from "../../../../redux/action/VendorPartner";
import CommonTable from "../../../candidates/Table";
import { CustomDiv } from "../../../chat-bot/style";
import SkillDeleteDialog from "../../../common-components/DeleteDialog";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../common-components/StyledComponents";
import CreateRecord from "../crm-view/components/CreateRecord";
import RatingStarIco from "../../../../assets/icons/RatingStarIco";
import parsePhoneNumber from "libphonenumber-js";

export default function Vendor() {
  const navigate = useNavigate();
  const [vendorList, setVendorList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
  });
  const [contact, setContact] = useState({
    open: false,
    disabled: false,
    createLoading: false,
    cancelLoading: false,
  });
  const [initialValues, setInitialValues] = useState({
    name: "",
    country: "",
    country_data: countries.map((country) => {
      return {
        name: `${country.name.common}`,
      };
    }),
    email: "",
    contact_number: "",
    loading: false,
    rating: 0,
  });
  const contactData = [
    {
      title: "Business Name",
      component: "input",
      titleName: "name",
      placeholder: "Enter the Name",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Country",
      component: "single-auto-complete",
      titleName: "country",
      placeholder: "Select the Country",
      dropDownData: "country_data",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter the Email Address",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Mobile Number",
      component: "phone-number",
      fontSize: "15px",
      country: "phone_country",
      titleName: "contact_number",
      placeholder: "Enter the Mobile Number",
      placeholderFontSize: "15px",
      mandatory: false,
    },

    // {
    //   title: "Mobile Number",
    //   component: "input",
    //   titleName: "contact_number",
    //   placeholder: "Enter the Mobile Number",
    //   placeholderFontSize: "15px",
    //   mandatory: false,
    // },
    {
      title: "Rating",
      component: "slider",
      titleName: "rating",
      placeholderFontSize: "15px",
      mandatory: false,
    },
  ];

  const [vendorDeleteButton, setVendorDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [headerData, setHeaderData] = useState([
    { name: "Unique Id", direction: "asc", sort: false },
    { name: "Name", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Rating", direction: "asc", sort: false },
    { name: "Created", direction: "asc", sort: false },
    { width: "5%" },
  ]);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
    id: "",
  });

  const handleAddVendorClick = async () => {
    setContact((prev) => ({
      ...prev,
      open: true,
    }));
    setInitialValues((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const listData = await JobIndustryList();
      setInitialValues((prev) => ({
        ...prev,
        available_industry: listData || [],
        loading: false,
      }));
    } catch (error) {
      setInitialValues((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
    // navigate(`/vendor/add`);
  };

  const handleFetchVendorCall = async () => {
    try {
      setVendorList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await VendorTableGetCall();
      setVendorList((prev) => ({
        ...prev,
        data: data?.data,
        loading: false,
      }));
    } catch (error) {
      setVendorList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleVendorDeleteClick = (e, list) => {
    e.stopPropagation();
    e.stopPropagation();
    setVendorDeleteButton((prev) => ({
      ...prev,
      open: true,
      content: list.business_name,
      id: list.id,
    }));
  };

  const handevendorlDialogClose = () => {
    setVendorDeleteButton({
      open: false,
      loading: false,
      content: "",
      id: "",
    });
  };

  const handleVendorDelete = async () => {
    setVendorDeleteButton((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await VendorDelete(vendorDeleteButton.id);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleFetchVendorCall();
      handevendorlDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setVendorDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleViewClick = (row) => {
    navigate(
      `/relationship-intelligence-view?type=Partner&title=${row.business_name}&id=${row.id}`
    );
  };

  const handleVendorTableBodyData = (row, index) => {
    return (
      <Fragment>
        <TableCell>{row.order_no}</TableCell>
        <TableCell>{row.business_name || "-"}</TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Inactive"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          <CommonGrid2
            display={"flex"}
            gap={"3px"}
            borderRadius={"50px"}
            padding={"2px 7px 2px 6px"}
            alignItems={"center"}
            width={"max-content"}
            background={
              row.rating > 4
                ? "#36A41D"
                : row.rating > 2.5
                ? "#F79009"
                : "#FF5C77"
            }
          >
            <RatingStarIco />
            <Typography
              variant="p"
              color="#fff"
              fontWeight={600}
              fontSize={"13px"}
            >
              {row.rating}
            </Typography>
          </CommonGrid2>
        </TableCell>
        <TableCell>
          {row.created_at ? moment(row.created_at).format("MMM DD, YYYY") : "-"}
        </TableCell>
        <TableCell>
          <CommonGrid2 display={"flex"} gap={"10px"} justifyContent={"end"}>
            <IconButton onClick={() => handleViewClick(row)}>
              <EyeIco />
            </IconButton>
            <IconButton onClick={(e) => handleVendorDeleteClick(e, row)}>
              <DeleteIco />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </Fragment>
    );
  };

  useEffect(() => {
    handleFetchVendorCall();
  }, []);

  const handleButttonClose = () => {
    setContact((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      createLoading: false,
      cancelLoading: false,
    }));
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    country: Yup.string().required("Country is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
    contact_number: Yup.string()
      .nullable()
      .test(
        "match-country",
        "Selected phone country does not match the user's country",
        function (value) {
          const { phone_country, country } = this.parent;

          if (!value) return true; // optional field
          if (!phone_country || !phone_country.name) return true;

          // Check: phone_country.name === country
          console.log(
            phone_country.name,
            country,
            "phone_country.name === country"
          );
          return phone_country.name === country;
        }
      )
      .test(
        "is-valid-phone",
        "Phone number is not valid for the selected country",
        function (value) {
          const { phone_country } = this.parent;

          if (!value) return true; // optional field
          if (!phone_country?.countryCode) return true;

          const formattedValue = value.startsWith("+") ? value : `+${value}`;

          const phoneNumber = parsePhoneNumber(
            formattedValue,
            phone_country.countryCode
          );

          return phoneNumber?.isValid();
        }
      ),
    // contact_number: Yup.string().required("Mobile Number is required"),
  });

  const handleSubmit = async (values) => {
    try {
      setContact((prev) => ({
        ...prev,
        disabled: true,
        createLoading: true,
      }));
      let payload = {
        business_name: values.name,
        country: values.country,
        contact_number: values.contact_number,
        email: values.email,
        rating: values.rating,
        notes: [],
      };
      const data = await CreateNewRelationshipCall("partner", payload);
      handleFetchVendorCall();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      handleButttonClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setContact((prev) => ({
        ...prev,
        disabled: false,
        createLoading: false,
      }));
    }
  };

  const handleContactClose = () => {
    setContact((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleButttonClose();
    }, 1000);
  };

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Grid2 container spacing={2} marginBottom={"2rem"}>
        <CommonGrid2
          size={{ xs: 12, md: 4, sm: 12 }}
          item
          alignItems={"center"}
          display={"flex"}
        >
          <Typography variant="h3">Vendors</Typography>
        </CommonGrid2>
        <CommonGrid2
          item
          size={{ xs: 12, md: 8, sm: 12 }}
          gap="10px"
          display="flex"
          justifyContent={"end"}
        >
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Add Vendors"
            padding="8px 20px"
            onClick={handleAddVendorClick}
          />
        </CommonGrid2>
      </Grid2>
      <CommonTable
        data={vendorList.data}
        columns={headerData}
        loadingRowLength={5}
        handleTableBodyData={handleVendorTableBodyData}
        withPagination={false}
        loading={vendorList.loading}
        handleRowClick={handleViewClick}
        customStyle={{
          "& .MuiTableRow-root": {
            cursor: "pointer",
          },
          "& .MuiTableRow-head": {
            cursor: "auto",
          },
        }}
      />

      <CreateRecord
        title={"Create New Vendor"}
        contact={contact}
        handleButttonClose={handleButttonClose}
        contactData={contactData}
        validationSchema={validationSchema}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        handleContactClose={handleContactClose}
      />

      <SkillDeleteDialog
        deleteDialog={vendorDeleteButton.open}
        handleDeleteDialogClose={handevendorlDialogClose}
        handleDeleteSkill={handleVendorDelete}
        buttonLoading={vendorDeleteButton.loading}
        title="Vendors"
        content={vendorDeleteButton.content}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
